module.exports = __webpack_public_path__ + "img/renew-failed.2e6f9817.png";